<template>
  <v-dialog v-model="dialog" max-width="1200px">
    <v-card>
      <v-card-title class="d-flex flex-column align-start pb-0">
        <p class="headline mb-5" style="width: 100%">
          {{ mess["dialog_assembly_article_title"] }}
        </p>
      </v-card-title>

      <v-card-text>
        <v-container
          class="pt-0 pl-0 pr-0"
          style="height: 300px; overflow-y: auto"
        >
          <v-data-table
            v-if="assemblyArticles"
            :headers="headers || []"
            :items="assemblyArticles || []"
            :locale="'ru'"
            hide-default-footer
            disable-pagination
            class="assembly-table elevation-0"
          >
            <template #header.availability="{ header }">
              <span v-html="header.text"> </span>
            </template>

            <template #item.name="{ item }">
              <a class="link link--table" :href="item.link" target="_blank">
                {{ item.name }}
              </a>
            </template>

            <template #item.availability="{ item }">
              {{ item.available }} / {{ item.transit }}
            </template>

            <template #item.shippingEstimate="{ item }">
              <shipping-estimate
                :item="item"
                :market-area="item.market_area_items.map(element => element.name)"
              />
            </template>

            <template #item.price="{ item }">
              <span v-if="item.showPrecent" class="price-percent">
                - {{ item.precent }} %
              </span>

              <div v-else>
                <div
                  v-if="item.newPrice"
                  class="d-flex flex-column cart-table__price"
                >
                  <s style="white-space: nowrap">{{ item.price }}</s>
                  <span style="white-space: nowrap">{{ item.newPrice }}</span>
                </div>

                <span v-else style="white-space: nowrap">{{ item.price }}</span>
              </div>
            </template>

            <template #item.quantity="{ item }">
              <button-counter
                v-model="item.quantity"
                :item="item"
                :lock-quantity="false"
              />
            </template>

            <template #item.action="{ item }">
              <action-buttons
                :item="item"
                :buttons="['cart', 'wishlist']"
                @added-to-cart="$emit('added-to-cart', $event)"
                @open-wishlist-dialog="$emit('open-wishlist-dialog', item)"
                @change-cart-items="
                  $store.dispatch('setCartItems', {
                    ...cartItems,
                    ...$event
                  })
                "
              />
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>

      <v-card-actions style="padding: 0 24px 16px">
        <v-spacer />

        <v-btn
          color="primary"
          class="elevation-0"
          dark
          @click="dialog = false"
        >
          {{ mess["dialog_base_button_close"] }}
        </v-btn>

        <v-btn
          :loading="Boolean(loading && assemblyArticles)"
          color="primary"
          class="elevation-0"
          dark
          @click="addToCart(assemblyArticles)"
        >
          {{ mess["assembly_add_all_to_card"] }}
        </v-btn>
      </v-card-actions>

      <v-btn
        absolute
        top
        right
        text
        icon
        @click="dialog = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-overlay
        :value="Boolean(loading && !assemblyArticles)"
        absolute
        color="white"
        opacity="0.5"
      >
        <v-progress-circular
          indeterminate
          size="64"
          color="primary"
        />
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
import ActionButtons from "@/components/ActionButtons";
import ButtonCounter from "@/components/ButtonCounter";
import ShippingEstimate from "@/components/ShippingEstimate";

import { mapGetters } from "vuex";
import isEmpty from "lodash/isEmpty";
import axios from "axios";

// Services
import { cartService } from "@/services/cart-service/cart-service";
import notifications from "@/models/notificationTemplates";

export default {
  name: "AssemblyArticleDialog",
  components: {
    ActionButtons,
    ButtonCounter,
    ShippingEstimate
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    currentArticle: {
      type: Object,
      default: () => ({})
    },
    singleRequest: {
      type: Boolean,
      default: true
    },
    marketArea: {
      type: Array,
      default: () => []
    }
  },
  data: function() {
    return {
      dialog: false,
      loading: false
    };
  },
  computed: {
    ...mapGetters({
      cartItems: "cartItems",
      assemblyArticles: "assemblyArticles"
    }),
    headers() {
      return [
        {
          text: this.mess["assembly_element_id"],
          value: "code"
        },
        {
          text: this.mess["assembly_product_name"],
          value: "name",
          sortByDefault: true
        },
        {
          text: this.mess["assembly_oem_article"],
          value: "oem",
          sortable: false
        },
        {
          text: this.mess["e_detail_availability"],
          value: "availability",
          sortable: false
        },
        {
          text: this.mess["assembly_shipping"],
          value: "shippingEstimate",
          sortable: false
        },
        {
          text: this.mess["assembly_price"],
          value: "price",
          sortable: false
        },
        {
          text: this.mess["assembly_count"],
          value: "quantity",
          sortable: false
        },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ];
    }
  },
  watch: {
    isVisible(val) {
      this.dialog = val;
      !val || this.getAssemblyArticles();
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  },
  methods: {
    getAssemblyArticles() {
      if (!isEmpty(this.assemblyArticles) && this.singleRequest) return;
      this.loading = true;
      axios
        .get(`/api/assemblyArticles?id=${this.currentArticle.id}`)
        .then(response => {
          this.$store.dispatch("setAssemblyArticles", response.data);
        })
        // eslint-disable-next-line no-console
        .catch(err => console.log(err))
        .finally(() => (this.loading = false));
    },
    addToCart(items) {
      this.loading = true;
      cartService
        .addArrayItemsToCart(items)
        .then(data => {
          if (data.success) {
            this.$store.dispatch("setCartItems", {
              ...this.cartItems,
              quantityString: data.items_text,
              quantity: data.items_count
            });
            this.$emit(
              "added-to-cart",
              items.length > 1
                ? notifications.success.addItemsToCart
                : notifications.success.addToCart
            );
          } else {
            this.$emit("added-to-cart", notifications.error.base);
            throw new Error("Server error");
          }
        })
        .catch(err => {
          this.$emit("added-to-cart", notifications.error.base);
          throw new Error(err);
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style lang="scss">
.assembly-table {
  &.v-data-table table th {
    padding: 0 10px;
    font-size: 10px;
    line-height: 14px;
    text-transform: uppercase;
    color: #555 !important;
    letter-spacing: 1px;
    font-weight: 400 !important;

    b {
      font-weight: 400 !important;
    }
  }

  &.v-data-table table td {
    padding: 2px 10px;
    color: #000000;
    font-size: 12px;
    line-height: 1.4;

    @media (max-width: 768px) {
      height: 40px !important;
    }
  }

  thead tr {
    vertical-align: baseline;
    line-height: 1;
  }

  a.link.link--table {
    display: block;
    color: #000000 !important;
    transition: color 150ms;
    text-decoration: none;

    &:hover {
      color: var(--v-primary-base) !important;
    }
  }

  .v-data-table__wrapper {
    padding-bottom: 50px;
  }
}
</style>
